import React from "react";
import styled from "styled-components";
import {Link} from "react-router";
import {Workflow, WorkflowInstance} from "common/flowmaster/types/workflow";
import ConfirmDialog from "common_components/confirm_dialog";
import {
  Typography,
  List,
  ListItemText,
  ListItem,
  IconButton,
} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import {OrganisationId} from "common/types/organisation";

interface DataAssetConfig {
  id: WorkflowInstance["id"];
  name: string;
  creation_date: string;
  is_archived: boolean;
}

interface WorkflowWithDataAssetConfigs extends Workflow {
  workflow_instances?: DataAssetConfig[];
}

const ListLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  pointer: cursor;
`;

type DataAssetDuplicateConfirmDialogProps = {
  dataAsset: Workflow;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  workflows: WorkflowWithDataAssetConfigs[];
  organisationId: OrganisationId;
};

export function DataAssetDuplicateConfirmDialog({
  dataAsset,
  open,
  onClose,
  onSuccess,
  workflows,
  organisationId,
}: DataAssetDuplicateConfirmDialogProps) {
  // Workflow objects in workflows state have workflow_instances which correspond to configs for this definition
  const configs =
    workflows
      .find(workflow => workflow.id === dataAsset.id)
      ?.workflow_instances?.filter(config => !config.is_archived) ?? [];
  const descriptionContent = (
    <>
      <Typography gutterBottom>
        {`Duplicating this data asset will duplicate ${configs.length} configurations associated with this asset:`}
      </Typography>
      <div style={{overflow: "auto", maxHeight: "30em"}}>
        <List dense>
          {configs.map(config => (
            <ListItem key={config.id}>
              <ListItemText
                primary={config.name}
                secondary={`Created at: ${new Date(
                  config.creation_date,
                ).toLocaleString()}`}
              />
              <ListLink
                onClick={e => {
                  e.stopPropagation();
                }}
                to={`/organisation/${organisationId}/data-assets/definition/${dataAsset.id}/config/${config.id}`}
              >
                <IconButton size="small" style={{padding: 0}}>
                  <LinkIcon />
                </IconButton>
              </ListLink>
            </ListItem>
          ))}
        </List>
      </div>
    </>
  );

  return (
    <ConfirmDialog
      open={open}
      onSuccess={onSuccess}
      onClose={onClose}
      title={`Duplicate Data Asset - "${dataAsset.name}" + ${configs.length} configurations"?`}
      description={descriptionContent}
      okButtonCaption="Yes"
      cancelButtonCaption="No"
    />
  );
}
